import { Select, Typography } from "antd";

const { Option } = Select;
const { Text } = Typography;

export function AppSelect({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Select an option",
  allowClear = false,
  rules = [],
  error = "",
  ...rest
}) {
  const handleChange = (val) => {
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <div className="d-flex flex-column">
      {label && <label htmlFor={name}>{label}</label>}
      <div className="mt-2" style={{ position: "relative" }}>
        {error && (
          <Text
            type="danger"
            style={{
              position: "absolute",
              top: "-20px", // move just above the select
              left: "0",
              fontSize: "14px",
            }}
          >
            {error}
          </Text>
        )}
        <Select
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          allowClear={allowClear}
          status={error ? "error" : ""}
          style={{ width: "100%" }}
          {...rest}
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
}

export default AppSelect;
